import React, { useState } from 'react'
import { postForm, ajaxDelete } from '../../ajax'
import AdminForm from './admin-modal'
import CsrForm from './csr-modal'
import FlashAlert from '../flash-alert'
import AlertPhones from './alert-phones'
import AlertEmails from './alert-emails'

const AdminsTab = props => {
  const [sdAdmins, setSdAdmins] = useState(props.sdAdmins)
  const [csrs, setCsrs] = useState(props.csrs)
  const [alertEmails, setAlertEmails] = useState(props.reservationAlertEmails)
  const [alertPhones, setAlertPhones] = useState(props.reservationAlertPhones)
  const [showAdminForm, setShowAdminForm] = useState(false)
  const [sdAdminToEdit, setSdAdminToEdit] = useState()
  const [showCsrForm, setShowCsrForm] = useState(false)
  const [csrToEdit, setCsrToEdit] = useState()
  const [alert, setAlert] = useState(null)

  const adminName = admin => `${admin.first_name} ${admin.last_name}`

  const handleAdminDelete = async (admin) => {
    const isConfirmed = window.confirm('Are you sure you want to delete this Admin?')
    if (!isConfirmed) return

    const url = `/admins/sd_admins/${admin.id}`
    const response = await ajaxDelete(url)
    await response.json()
      .then(json => {
        json.error ? setAlert({text: json.error, type: 'alert'}) : window.location.href = '/admins/sd_admins'
      })
  }

  const handleCsrDelete = async (csr) => {
    const isConfirmed = window.confirm('Are you sure you want to delete this CSR?')
    if (!isConfirmed) return

    const url = `/admins/customer_service_reps/${csr.id}`
    const response = await ajaxDelete(url)
    await response.json()
      .then(() => {
        window.location.href = '/admins/sd_admins'
      })
  }

  const handlePhoneDeleted = async (phone) => {
    const isConfirmed = window.confirm('Are you sure you want to delete this Phone?')
    if (!isConfirmed) return

    const url = `/admins/reservation_alerts/phone.json?phone=${phone}`
    const response = await ajaxDelete(url)
    await response.json()
      .then(() => {
        window.location.href = '/admins/sd_admins'
      })
  }

  const handlePhoneAdded = async (phone) => {
    const formData = new FormData()
    formData.append('user[phone]', phone)

    postForm('/admins/reservation_alerts/phone.json', formData)
    .then(response => { return response.json() })
    .then((json) => {
      setAlertPhones([json.phone, ...alertPhones])
    })
  }

  const handleEmailDeleted = async (email) => {
    const isConfirmed = window.confirm('Are you sure you want to delete this Email?')
    if (!isConfirmed) return

    const url = `/admins/reservation_alerts/email.json?email=${email}`
    const response = await ajaxDelete(url)
    await response.json()
      .then(() => {
        window.location.href = '/admins/sd_admins'
      })
  }


  const handleEmailAdded = async (email) => {
    const formData = new FormData()
    formData.append('email', email)

    postForm('/admins/reservation_alerts/email.json', formData)
    .then(response => { return response.json() })
    .then((json) => {
      setAlertEmails([json.email, ...alertEmails])
    })
  }

  const handleEditAdmin = () => {
    setShowAdminForm(true)
    setSdAdminToEdit(props.currentUser)
  }

  const handleEditCsr = csr => {
    setShowCsrForm(true)
    setCsrToEdit(csr)
  }

  const handleAdminCreated = admin => {
    setSdAdmins([admin, ...sdAdmins])
    setShowAdminForm(false)
  }

  const handleAdminUpdated = admin => {
    const updatedAdmins = sdAdmins
    const index = updatedAdmins.findIndex(a => a.id == admin.id)
    updatedAdmins[index] = admin

    setSdAdmins(updatedAdmins)
    setShowAdminForm(false)
    setSdAdminToEdit()
  }

  const handleCsrCreated = csr => {
    setCsrs([csr, ...csrs])
    setShowCsrForm(false)
  }

  const handleCsrUpdated = csr => {
    const updatedCsrs = csrs
    const index = updatedCsrs.findIndex(c => c.id == csr.id)
    updatedCsrs[index] = csr

    setCsrs(updatedCsrs)
    setShowCsrForm(false)
    setCsrToEdit()
  }

  return (
    <div className='wrapper'>
       { alert && <FlashAlert text={alert.text} type={alert.type} constant centred onHide={() => setAlert(null)} />}
      <br />
      <div className='row'>
        <div className='col-lg-12'>
          <a onClick={() => setShowAdminForm(true)} className='btn btn-success'>
            <div className='fa fa-plus' />
            Add new admin
          </a>
          <a onClick={() => handleEditAdmin()} className='btn btn-success'>
            <div className='fa fa-pencil' />
            Edit my data
          </a>
        </div>
      </div>
      <div className='row'>
        <div className='col-lg-6'>
          <table className='table table-striped'>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th />
              </tr>
            </thead>
            <tbody>
              { sdAdmins.map((admin) => {
                return (
                  <tr key={ admin.id }>
                    <td>{ adminName(admin) }</td>
                    <td>{ admin.email }</td>
                    <td>
                      { admin.id != props.currentUser.id &&
                        <a onClick={() => handleAdminDelete(admin)}>
                          <div className='fa fa-remove' />
                        </a>
                      }
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
        <div className='col-lg-6'>
          <div className='csr-profile-block'>
            <div className='employees-list'>
              <h3 className='admin-profile_block__title'>Customer Service Reps</h3>
              { csrs.map((csr) => {
                return (
                  <div key={ csr.id } className='employee-row'>
                    <div className='employee-row__grey'>
                      <div className='employee-row__edit'>
                        <a onClick={() => handleEditCsr(csr)} className='employee-row__pencil edit-admin'>
                          <i className='fa fa-pencil' />
                        </a>
                      </div>
                      <div className='employee-row__name'>{`${csr.first_name} ${csr.last_name}`}</div>
                      <div className='employee-row__email'>{csr.email}</div>
                      <div className='employee-row__role'>Customer Service Rep</div>
                    </div>
                    <div className='employee__destroy'>
                      <a onClick={() => handleCsrDelete(csr)} className='employee-row__cross delete-admin'>
                        <i className='fa fa-remove' />
                      </a>
                    </div>
                  </div>
                )
              })}
            </div>
            <a onClick={() => setShowCsrForm(true)} className='btn employees-list__btn'>
              + Add Customer Service Rep
            </a>
          </div>
        </div>
      </div>
      <hr />
      <h3>
        <i className='fa fa-angle-right' /> Alerts
      </h3>
      <div className='admin-alerts'>
        <AlertPhones
          alertPhones={alertPhones}
          onAddPhone={(phone) => handlePhoneAdded(phone)}
          onDeletePhone={(phone) => handlePhoneDeleted(phone)}
        />
        <AlertEmails
          alertEmails={alertEmails}
          onAddEmail={(email) => handleEmailAdded(email)}
          onDeleteEmail={(email) => handleEmailDeleted(email)}
        />
      </div>
      { showAdminForm &&
        <AdminForm
          sdAdmin={sdAdminToEdit}
          onClose={() => {
            setShowAdminForm(false)
            setSdAdminToEdit()
          }}
          onUpdate={(admin) => handleAdminUpdated(admin)}
          onCreate={(admin) => handleAdminCreated(admin)}
          onError={(message) => {
            setAlert({text: message, type: 'alert'})
            setShowAdminForm(false)
            setSdAdminToEdit()
          }}
        />
      }
      { showCsrForm &&
        <CsrForm
          csr={csrToEdit}
          onClose={() => {
            setShowCsrForm(false)
            setCsrToEdit()
          }}
          onUpdate={(csr) => handleCsrUpdated(csr)}
          onCreate={(csr) => handleCsrCreated(csr)}
          onError={(message) => {
            setAlert({text: message, type: 'alert'})
            setShowCsrForm(false)
            setCsrToEdit()
          }}
        />
      }
    </div>
  )
}

export default AdminsTab
